// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5lgNs","title":"styles_title__2inMB"};